import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useMatch } from 'react-router-dom';

const ScrollToTop = ({ children }: { children: React.ReactElement }) => {
  const location = useLocation();
  const mainChecker = useMatch('/:name/*')?.params.name;

  useEffect(() => {
    if (mainChecker === 'cabinet') {
      return;
    }

    window.scrollTo(0, 0);
  }, [location]);

  return <>{children}</>;
};

export default ScrollToTop;
